import { hrDateWithTime } from "@king-ict/eupisi-ui/utils";

export const formatDateTimeWithUser = (
  date: Date | null | undefined,
  user?: { firstName?: string; lastName?: string }
) => {
  if (!date) return "";
  const { firstName, lastName } = user || {};

  const dateTime = hrDateWithTime(date);
  if (!firstName || !lastName) return dateTime;

  return `${dateTime}, ${firstName} ${lastName}`;
};
